// Which of the two modes this page is in (docs/SPEC.md "Two stages, two modes"): "public" (nowish.fyi, logged out:
// browse only) or "personal" (Micah's private addresses: everything). The server decides, from how the page was
// reached, and writes it into the page (<meta name="nowish-mode">, backend/nowish/api.py site_page); the server also
// refuses every personal request from the public site, so nothing here is what keeps it safe. Without the meta (the
// dev server) it's personal.
export type Mode = "public" | "personal";

export const MODE: Mode =
  typeof document !== "undefined" && document.querySelector('meta[name="nowish-mode"]')?.getAttribute("content") === "public"
    ? "public" : "personal";
